// src/components/CallbackCleaner.js
import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useLocation } from 'react-router-dom';

const CallbackCleaner = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && isAuthenticated && location.search.includes('code=')) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, isLoading, location.search, navigate]);

  return null;
};

export default CallbackCleaner;